import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function WardsPage({ t, onBack, onWard }) {
  return (
    <SimplePage title="Vijayanagar - Greater Bangalore Authority · 13 Wards" onBack={onBack}>
      <div className="ward-page-intro">
        <h2>About Vijayanagar, Bengaluru</h2>

        <p>
          Vijayanagar is a well-established residential and commercial area
          in western Bengaluru, Karnataka. The locality is known for its
          established neighbourhoods, markets, schools, healthcare facilities,
          public services, parks, temples, places of worship, and good
          connectivity to other parts of the city.
        </p>

        <p>
          The wider Vijayanagar area includes a number of residential
          neighbourhoods and localities that form an important part of
          Bengaluru's western side. Residents use a range of civic services,
          including roads, drainage, water supply, street lighting, waste
          management, public spaces, and other municipal facilities.
        </p>

        <p>
          This page provides an easy way for residents to explore the
          <strong> 13 wards of Vijayanagar</strong>. Select your ward below to
          find ward-specific information and access relevant civic services.
        </p>

        <div className="ward-info-box">
          <strong>Explore your ward</strong>
          <span>
            Select a ward below to view its local information and available
            civic services.
          </span>
        </div>
      </div>

      <div className="ward-grid">
        {VIJAYANAGAR_WARDS.map((ward) => (
          <button
            className="ward-card"
            key={ward.number}
            onClick={() => onWard(ward)}
          >
            <span className="ward-number">Ward {ward.number}</span>
            <strong>{ward.name}</strong>
            <ArrowRight size={17} />
          </button>
        ))}
      </div>
    </SimplePage>
  );
}


export default WardsPage;
